<template>
  <div>
    <v-select
      v-model='address'
      :items='addresses'
      :label='label'
      :no-data-text="$t('address_select.no_contacts_found')"
      centre
      required
      solo
      :loading='loading'
      @change='changed'
    ></v-select>
  </div>
</template>

<script>
export default {
  props: ['label', 'items', 'type'],
  data: () => ({
    address: null,
    addresses: [],
    loading: false
  }),

  created() {
    this.display();
  },

  methods: {
    display() {
      this.loading = true;
      setTimeout(() => {
        this.prepareForShowing();
      }, 300);
      this.loading = false;
    },

    prepareForShowing() {
      let itemsToShow = [];
      this.items.forEach(address => {
        itemsToShow.push({
          text: address['street'],
          value: address['id']
        });
      });
      this.addresses = itemsToShow;
    },

    changed() {
      this.$emit('addressSelected', { type: this.type, value: this.address });
    }
  }
};
</script>
